import React from "react";
import { Offcanvas } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { hideNavAction } from "../store/actions/showNavAction";

function NavbarToggle() {
  const dispatch = useDispatch();
  const show = useSelector((state) => state.showNav);
  return (
    <Offcanvas
      // show={showNav}
      // onHide={() => setShowNav(false)}
      show={show}
      onHide={() => dispatch(hideNavAction())}
      placement="start"
    >
      <Offcanvas.Header closeButton></Offcanvas.Header>
      <Offcanvas.Body>
        <div className="d-flex flex-column p-1 gap-2">
          <Link className="text-black" to="/">
            Inicio
          </Link>
          <Link className="text-black" to="/productos">
            Productos
          </Link>
          <Link className="text-black" to="/sobre-nosotros">
            Sobre el proyecto
          </Link>
        </div>
      </Offcanvas.Body>
    </Offcanvas>
  );
}

export default NavbarToggle;
